

import React, { useMemo, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import FileOpenOutlinedIcon from '@mui/icons-material/FileOpenOutlined';
// import { makeStyles } from "@mui/styles";
import { Box, Grid, Button, Typography } from '@mui/material'
//import { updateState } from "../../../redux/selectedFilesSlice";
import { useDispatch, useSelector } from "react-redux";
// import { customTheme as theme } from '../theme/customTheme';
import File from '../../../assets/file.svg'
import "@fontsource/rubik";
import usePermissions from '../../../hooks/usePermissions';
import { PERMISSION } from '../../../constants/constants';
import useCustomTheme from '../../../theme/useCustomTheme';


const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};


const MediaFilesDropzone = (props) => {

    const [tempFiles, setTempFiles] = useState([]);
    const dispatch = useDispatch()
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const [isDropped, setIsDropped] = useState(false);
    const [selectedEventId, setSelectedEventId] = useState(null)
    const [selectedProjectName, setSelectedProjectName] = useState('')
    const [uploadedVideoList, setUploadedVideoList] = useState([]);
    const [enableUploadList, setEnableUploadList] = useState(false);
    const [hasPermission] = usePermissions()
    const [theme ] = useCustomTheme()
 

    const {
        height,
        //width,
        setFiles,
        setProgress,
        setUploadStatus,
        isDisabled = true,
        setRequestController,
        eventData,
        setEventData,
        refetch,
        refetchEvent,
        listOfAllEvents,flex,
        button,
        setVideoFile,
        onProceedClick
    } = props;

    const baseStyle = {
        // height:'20rem',
        // width:'30rem',
        // flex: 1,
       // height: height,
        width: '100%',
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "2em",
        borderWidth: 3,
        borderRadius: 2,
        boxShadow: '0px 5px 15px #00000029',
        borderColor: "#FFFFFF",
        borderStyle: "dashed",
        backgroundColor: "#e6e6e6b3",
        color: "#bdbdbd",
        outline: "none",
        transition: "border .24s ease-in-out",
    };

    const {
        open,
        acceptedFiles,
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject,
    } = useDropzone({
        maxFiles: 1, 
        noClick: true,
        noKeyboard: true,
        disabled: isDisabled,
        accept: {
            'video/mp4': ['.mp4'],
            'video/x-msvideo': ['.avi'],
            'video/quicktime': ['.mov'],
            'video/webm': ['.webm'],
            'video/x-flv': ['.flv'],
            'video/3gpp': ['.3gp'],
          },
     
        onDrop: (acceptedFiles) => {
            setIsDropped(true)
                setTempFiles(
                    acceptedFiles.map((file) =>
                        Object.assign(file, {
                            preview: URL.createObjectURL(file),
                        })
                    )
                );
             
            // }
         
        },
    });

    // useEffect(()=>{

    // }, tempFiles)

    useEffect(() => {
        // setRequestController(
        //     tempFiles?.map(() => {
        //         return new AbortController();
        //     })
        // );
        // setProgress(
        //     tempFiles?.map(() => {
        //         return 0;
        //     })
        // );
        // setUploadStatus(
        //     tempFiles?.map(() => {
        //         return { type: "standard", message: "Waiting..." };
        //     })
        // );
        // setFiles(tempFiles);
        // setVideoFile(tempFiles[0].preview)
        tempFiles?.map(file => setVideoFile(file?.preview))
        // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
        return () => tempFiles.forEach((file) => URL.revokeObjectURL(file.preview));
    }, [tempFiles]);

    const onProceedClickFunction =()=>{
        setRequestController(
            tempFiles?.map(() => {
                return new AbortController();
            })
        );
        setProgress(
            tempFiles?.map(() => {
                return 0;
            })
        );
        setUploadStatus(
            tempFiles?.map(() => {
                return { type: "standard", message: "Waiting..." };
            })
        );
        setFiles(tempFiles);
    }

    useEffect(()=>{
        if(onProceedClick){
            onProceedClickFunction()
        }
    },[onProceedClick])

    useEffect(()=> {
        if(refetch) {
            refetch()
            setFiles([])
        }
    }, [])


    const style = useMemo(
        () => ({
            ...baseStyle,
            ...(isFocused ? focusedStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [isFocused, isDragAccept, isDragReject]
    );

    const browseFilesClickHandler = async ()=>{
           
            // if(commonReducer.event_details?.consent_accepted == false){
            //     dispatch(updateState({open_agreement_popup: true}))  
            // }else{
                open()   
                
            
    }



    return (
        <Box style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

            <Grid className="container" 
                style={{ display:button ? 'none': 'flex' }} 
                sx={{ 
                    display: { xs: 'none', md:button ? 'none' : 'inline' },
                    height: height ? height : {xs: '60vh', md: '55vh',lg: '55vh' , xl: '56vh'}, 
                    width: '100%'
            }}>

                <Grid  {...getRootProps({ style, className: 'dropzone' , display:button && 'none'})} >
                    <input {...getInputProps()} />
                    <Box style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center', height: '100%' }}>

                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', alignItems: 'center', width: '100%',}} gap={2}>
                            <Box sx={{ display: button ?'none' :'flex', flexDirection: 'row', justifyContent: 'end', alignItems: 'center', width: '50%',}} >

                                <Box sx={{ width:  {xs:'25px',md:'30px',lg:'50px',xl:'74px'}, height:{xs:'20px',md:'25px',lg:'38px',xl:'50px'}, color: '#878887', marginBottom: flex === 'row' ? 0 : {xs:'5px',md:'10px',lg:'15px',xl:'30px'}, }} >
                                 <img src={File} height='100%' width='100%'/>
                             </Box>
                            </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'start', width: '80%',gap:0.5 }}>

                            <Typography sx={{ fontSize: {xs:'8px',sm:'9px',md:'10px',lg:'14px',xl:'25px'}, fontWeight: 600, margin: 0, padding: 0, textAlign: 'center', letterSpacing: 1.25, color: '#878887', fontFamily: "Rubik" , display: button && 'none'}}>Drag & Drop existing files here</Typography>

                            <Button color='secondary' variant='contained' disabled = {isDisabled} onClick={browseFilesClickHandler} style={{ fontFamily: "Rubik", backgroundColor: isDisabled == true? "#52636C50"  : theme.palette.secondary.main, borderRadius: '5px', border: 'none',  cursor: 'pointer', fontWeight: 600, textTransform: 'capitalize', minWidth:'76px' }} sx={{fontSize:{xs:'7px',sm:'8px',md:'9px',lg:'11px',xl:'16px', },fontWeight:600, 
                            // width:{xs:'76px',sm:'76px',md:'76px',lg:'86px',xl:'129px'},
                            paddingY:{xs:0.2,lg:0.2}}}>
                                Or Browse
                            </Button>
                        </Box>

                        </Box>
                        
                    </Box>
                </Grid>
               
            </Grid>

            <Box
        sx={{ display: { xs: "flex" }, paddingTop: 0, width: '100%'}}
        alignItems="center"
        justifyContent="center"
      >
        <Button
          type="button"
          disabled={isDisabled}
        //   startIcon ={<AddIcon style={{ fontSize: "48px", fontWeight: 900}} />}
          onClick={browseFilesClickHandler}
          color='secondary'
          variant="contained"
          style={{
            cursor: !isDisabled && "pointer",
            // color: "#08231B",
            // backgroundColor: isDisabled == true ? "#52636C50" : theme.palette.secondary.main,
            borderRadius: "10px",
            border: "none",
            fontSize: "20px",
            fontWeight: 700,
            padding: "5px",
            fontFamily: 'Rubik'
            
          }}
          sx={{ boxShadow: 3, width: '100%', minWidth: "100px", mt: 2, textTransform: 'none' }}
        >
          Select Video
        </Button>
      </Box>

        </Box>
    );
}

export default MediaFilesDropzone;